import type { Subscription } from '@/core/domain';
import type { SubscriptionRepository } from '../../domain/repositories/subscription-repository';
import type { SubscriptionRemoteDataSource } from '../datasources/remote';

export class SubscriptionRepositoryImpl implements SubscriptionRepository {
  constructor(private readonly remote: SubscriptionRemoteDataSource) {}

  async getByUserId(userId: string): Promise<Subscription | null> {
    return this.remote.getByUserId(userId);
  }

  async getByUserIds(userIds: string[]): Promise<Map<string, Subscription | null>> {
    return this.remote.getByUserIds(userIds);
  }
}
